/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkprompt2Inputs */

const en_profilelinkprompt2 = /** @type {(inputs: Profilelinkprompt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer on the go? Connect your Pulsify profile and requests arrive as notifications on your phone.`)
};

const de_profilelinkprompt2 = /** @type {(inputs: Profilelinkprompt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterwegs antworten? Verbinde dein Pulsify-Profil, dann kommen Anfragen als Mitteilung aufs Handy.`)
};

/**
* | output |
* | --- |
* | "Answer on the go? Connect your Pulsify profile and requests arrive as notifications on your phone." |
*
* @param {Profilelinkprompt2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkprompt2 = /** @type {((inputs?: Profilelinkprompt2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkprompt2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkprompt2(inputs)
	return de_profilelinkprompt2(inputs)
});
export { profilelinkprompt2 as "profileLinkPrompt" }